import { render, staticRenderFns } from "./ManualImportPage.vue?vue&type=template&id=6a51f26e&scoped=true&"
import script from "./ManualImportPage.vue?vue&type=script&lang=js&"
export * from "./ManualImportPage.vue?vue&type=script&lang=js&"
import style0 from "./ManualImportPage.vue?vue&type=style&index=0&id=6a51f26e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a51f26e",
  null
  
)

export default component.exports